export const trimLastSlash = (str: string) => {
  if (!str) {
    return ''
  }
  return str.replace(/\/$/, '')
}
